import { render, staticRenderFns } from "./ProgramMaterial.vue?vue&type=template&id=12ba8d9c&scoped=true"
import script from "./ProgramMaterial.vue?vue&type=script&lang=js"
export * from "./ProgramMaterial.vue?vue&type=script&lang=js"
import style0 from "./ProgramMaterial.vue?vue&type=style&index=0&id=12ba8d9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ba8d9c",
  null
  
)

export default component.exports